import BioSearchSetting from './BioSearchSetting.vue';
import { getDefaultSettings, getDefaultAlgorithm, getShortDefaultAlgorithm } from './components/defaultSettings';

BioSearchSetting.getDefaultSettings = getDefaultSettings;
BioSearchSetting.getDefaultAlgorithm = getDefaultAlgorithm;
BioSearchSetting.getShortDefaultAlgorithm = getShortDefaultAlgorithm;

export default BioSearchSetting;
